import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import axios from "axios";

const MaintenanceRedirect = ({ children }) => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkStatus = async () => {
      if (location.pathname !== "/maintenance") {
        try {
          const result = await axios.get("/api/auth/status");
          setResponse(result.data);
          
          // Redirect to maintenance page if in outage and not already there
          if (result.data?.isInOutage) {
            navigate("/maintenance", { replace: true });
          }
        } catch (err) {
          console.error("Failed to fetch status:", err);
        }
      }
      setLoading(false);
    };

    checkStatus();
  }, [location.pathname, navigate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If in outage, don't render children (will redirect in useEffect)
  if (response?.isInOutage) {
    return null;
  }

  return children;
};

export default MaintenanceRedirect;
